var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftD(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "117px",
    height: "32px",
    viewBox: "0 0 117 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectangle Copy 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Member_Q2_D",
    transform: "translate(-618.000000, -119.000000)",
    fill: "#E5744B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-4",
    transform: "translate(618.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,0 L100.467109,0 C100.734447,1.70483254e-14 100.990654,0.107044191 101.17853,0.297233997 L115.996042,15.297234 C116.380813,15.6867446 116.380813,16.3132554 115.996042,16.702766 L101.17853,31.702766 C100.990654,31.8929558 100.734447,32 100.467109,32 L1,32 C0.44771525,32 3.01276883e-12,31.5522847 3.0127012e-12,31 L3.0127012e-12,1 C3.01252254e-12,0.44771525 0.44771525,1.01453063e-16 1,0 Z",
    id: "Rectangle-Copy-7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftD);
export default __webpack_public_path__ + "static/media/leftD.bfe41c2c3308db5e795104cc59fec839.svg";
export { ForwardRef as ReactComponent };